import { Component, ViewChild, inject } from '@angular/core';
import { CompanyPolicyTypeFormComponent } from '../company-policy-type-form/company-policy-type-form.component';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { CompanyPolicyTypeService } from '../../../Model/CompanyPolicyType/company-policy-type.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';

@Component({
  selector: 'app-company-policy-type',
  standalone: true,
  imports: [FormsModule, CommonModule, DataTablesModule],
  templateUrl: './company-policy-type.component.html',
  styleUrl: './company-policy-type.component.scss'
})
export class CompanyPolicyTypeComponent {
  CompanyPolicyTypeData = [];
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  private modalService = inject(NgbModal);
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective
  dtoptions: DataTables.Settings = {};
  constructor(
    private companyPolicyType: CompanyPolicyTypeService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private toast: ToastService,
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.GetCompanyPolicyType();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  GetCompanyPolicyType() {
    this.isDisabled = true;
    this.companyPolicyType.GetCompanyPolicyType({ ESS_CompanyPolicyTypeMasterID: 0, SelectType: 1 }).subscribe({
      next: (response) => {
        this.CompanyPolicyTypeData = Object.values(response.Table)
        //this.DataTable.LoadData(response.Table);
        console.log(response);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          // Destroy the table first
          dtInstance.destroy();
          // Call the dtTrigger to rerender again
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  addCompanyPolicyType(ID: any) {
    if ((this.common.PageRight.IsAdd && ID == 0) || (this.common.PageRight.IsEdit && ID > 0)) {
      const modalRef = this.modalService.open(CompanyPolicyTypeFormComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.ID = ID;

      modalRef.result.then((result: any) => {
        if (result) {
          this.GetCompanyPolicyType();
        }

      }).catch(() => {
        // Modal dismissed
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }
}
